import { render, staticRenderFns } from "./Plyr.vue?vue&type=template&id=2abb5926&scoped=true&"
import script from "./Plyr.vue?vue&type=script&lang=js&"
export * from "./Plyr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb5926",
  null
  
)

export default component.exports